<template>
    <LayoutPayment>
        <div class="container-fluid banner-pm pb-5">
            <BlockBack
                step="1/4"
                title="Thông tin đăng ký"
                @click-back="backToHome"
                style="position: relative; z-index: 999"
            />
            <!-- BLOCK PAYMENT - INFO PERSONAL -->
            <section class="mt-4 mb-4 sec-payment">
                <!-- box header -->
                <div class="container w-736 sec-plb-inside rd-t rd-b box-sdow">
                    <!-- info box -->
                    <div class="row box-info">
                        <div class="col-12">
                            <div class="pdx09 py-4">
                                <!-- headline -->
                                <h4 class="text-16 text-bold mb-3 d-flex align-items-center">
                                    <i class="d-block mr-3 ico-orange">
                                        <svg aria-hidden="true" width="20" height="20" title="FPT TELECOM">
                                            <use
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                xlink:href="#icon-info-orange"
                                            ></use>
                                        </svg>
                                    </i>
                                    <span>Thông tin cá nhân</span>
                                </h4>
                                <!-- info -->
                                <div class="form-infomation">
                                    <form>
                                        <!-- NAME -->
                                        <inputForm
                                            id="name"
                                            title="Họ và tên"
                                            type="text"
                                            placeholder="Nguyễn Văn A"
                                            maxlength="100"
                                            :required="true"
                                            :input_error="errors.fullname"
                                            v-model="fields.fullname"
                                        />

                                        <div class="form-group form-row">
                                            <!-- PHONE -->
                                            <inputForm
                                                id="phone"
                                                title="Số điện thoại"
                                                type="number"
                                                placeholder="0988555555"
                                                maxlength="10"
                                                :required="true"
                                                :input_error="errors.phonenumber"
                                                v-model="fields.phonenumber"
                                                :col="true"
                                            />

                                            <!-- Birthday -->
                                            <div class="col form-group">
                                                <label for="birthday"
                                                    >Ngày sinh <span class="required clo-red text-20">*</span></label
                                                >
                                                <input
                                                    v-model="fields.birthday"
                                                    type="text"
                                                    id="birthday"
                                                    class="form-control"
                                                    placeholder="dd/mm/yyyy"
                                                    maxlength="10"
                                                />
                                                <small
                                                    v-if="errors.hasOwnProperty('birthday')"
                                                    class="form-text text-12 clo-red"
                                                >
                                                    {{ errors.birthday }}
                                                </small>
                                            </div>
                                        </div>

                                        <div class="form-group form-row">
                                            <!-- CMND -->
                                            <inputForm
                                                id="cmnd"
                                                title="Số cmnd/cccd "
                                                type="number"
                                                placeholder="000 000 000 000"
                                                maxlength="12"
                                                :required="true"
                                                :input_error="errors.idNumber"
                                                v-model="fields.idNumber"
                                                :col="true"
                                            />

                                            <!-- Gender -->
                                            <div class="col form-group less-border">
                                                <label for="gender">Giới tính</label>
                                                <Select2
                                                    placeholder="Chọn giới tính"
                                                    v-model="fields.sex"
                                                    :options="listGender"
                                                />
                                                <small
                                                    v-if="errors.hasOwnProperty('sex')"
                                                    class="form-text text-12 clo-red"
                                                >
                                                    {{ errors.sex }}
                                                </small>
                                            </div>
                                        </div>

                                        <!-- Email -->
                                        <inputForm
                                            id="email"
                                            title="Địa chỉ email"
                                            type="text"
                                            placeholder="email@gmail.com"
                                            maxlength="50"
                                            :input_error="errors.email"
                                            v-model="fields.email"
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <UtmBannerRegister
                    serviceCode="fpt-play"
                />

                <div class="container w-736 sec-plb-inside rd-t mt-4 rd-b box-sdow">
                    <!-- info box -->
                    <div class="row box-info">
                        <div class="col-12">
                            <div class="pdx09 py-4">
                                <h4 class="text-16 text-bold mb-3 d-flex align-items-center">
                                    <i class="d-block mr-3 ico-orange">
                                        <svg aria-hidden="true" width="20" height="20" title="FPT TELECOM">
                                            <use
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                xlink:href="#icon-address-orange"
                                            ></use>
                                        </svg>
                                    </i>
                                    <span>Địa chỉ lắp đặt</span>
                                </h4>
                                <div class="form-infomation">
                                    <!-- NAME -->
                                    <!-- CITY -->
                                    <div class="form-group">
                                        <Select2
                                            placeholder="Chọn Tỉnh/Thành phố"
                                            v-model="dataLocation.locationid"
                                            :options="listLocation"
                                            @change="getDistrict($event)"
                                        />
                                        <small
                                            v-if="errors.hasOwnProperty('locationid')"
                                            class="form-text text-12 clo-red"
                                        >
                                            {{ errors.locationid }}
                                        </small>
                                    </div>
                                    <!-- DISTRICT -->
                                    <div class="form-group">
                                        <Select2
                                            placeholder="Chọn Quận/Huyện"
                                            v-model="dataLocation.districtid"
                                            :options="listDistrict"
                                            @change="getWard($event)"
                                        />
                                        <small
                                            v-if="errors.hasOwnProperty('district')"
                                            class="form-text text-12 clo-red"
                                        >
                                            {{ errors.district }}
                                        </small>
                                    </div>
                                    <!-- WARD -->
                                    <div class="form-group">
                                        <Select2
                                            placeholder="Chọn Phường/Xã"
                                            v-model="dataLocation.wardid"
                                            :options="listWard"
                                            @change="getStreet($event)"
                                        />
                                        <small v-if="errors.hasOwnProperty('ward')" class="form-text text-12 clo-red">
                                            {{ errors.ward }}
                                        </small>
                                    </div>
                                    <!-- STREET -->
                                    <div class="form-group">
                                        <Select2
                                            placeholder="Chọn Đường/phố"
                                            v-model="dataLocation.streetid"
                                            :options="listStreet"
                                            @change="checkStreet"
                                        />
                                        <small v-if="errors.hasOwnProperty('street')" class="form-text text-12 clo-red">
                                            {{ errors.street }}
                                        </small>
                                        <input
                                            v-if="parseInt(dataLocation.is_street_user) === 1"
                                            v-model="dataLocation.street_user"
                                            type="text"
                                            class="form-control"
                                            name="address_user"
                                            id="address_user"
                                            aria-describedby=""
                                            maxlength="30"
                                            placeholder="Nhập tên đường/phố"
                                        />
                                        <small
                                            v-if="errors.hasOwnProperty('street_user')"
                                            class="form-text text-12 clo-red"
                                        >
                                            {{ errors.street_user }}
                                        </small>
                                    </div>
                                    <div class="form-group form-row">
                                        <div class="col-md-6 mb-3 mb-md-0">
                                            <div class="iradio checked d-flex align-items-center">
                                                <!-- input radio -->
                                                <input
                                                    class="default-radio"
                                                    type="radio"
                                                    name="send[]"
                                                    id="send[1]"
                                                    value="1"
                                                    v-model="dataLocation.locationtype"
                                                />
                                                <!-- label -->
                                                <label
                                                    class="mx-3 d-flex align-items-center"
                                                    for="send[1]"
                                                    @click="dataLocation.locationtype = 1"
                                                >
                                                    <span class="text-bold text-16 clo-black">Nhà riêng </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="iradio checked d-flex align-items-center">
                                                <!-- input radio -->
                                                <input
                                                    class="default-radio"
                                                    type="radio"
                                                    name="send[]"
                                                    id="send[2]"
                                                    value="2"
                                                    v-model="dataLocation.locationtype"
                                                />
                                                <!-- label -->
                                                <label
                                                    class="mx-3 d-flex align-items-center"
                                                    for="send[2]"
                                                    @click="dataLocation.locationtype = 2"
                                                >
                                                    <span class="text-bold text-16 clo-black">Chung cư </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- ADDRESS -->
                                    <!-- ADDRESS -->
                                    <!-- Danh cho nha rieng-->
                                    <template v-if="dataLocation.locationtype == '1'">
                                        <inputForm
                                            id="address"
                                            title="Địa chỉ/Số nhà"
                                            type="text"
                                            :placeholder="housenumberHint"
                                            maxlength="30"
                                            :input_error="errors.housenumber"
                                            v-model="dataLocation.housenumber"
                                        />
                                    </template>
                                    <!-- Danh cho chung cu-->
                                    <template v-else>
                                        <div class="form-group">
                                            <Select2
                                                placeholder="Chọn Chung cư"
                                                v-model="dataLocation.buildingid"
                                                :options="listBuilding"
                                                @change="changeApartment"
                                            />
                                            <input
                                                v-model="dataLocation.buildingname"
                                                type="text"
                                                class="form-control"
                                                id="building"
                                                aria-describedby=""
                                                :placeholder="placeholderText.apartment"
                                                maxlength="50"
                                                v-if="dataLocation.buildingid == 99999"
                                            />
                                            <small
                                                v-if="errors.hasOwnProperty('building') && dataLocation.buildingid == 99999"
                                                class="form-text text-12 clo-red"
                                            >
                                                {{ errors.building }}
                                            </small>
                                        </div>
                                        <inputForm
                                            id="block"
                                            title="toà nhà/Lô/block"
                                            type="text"
                                            :placeholder="placeholderText.block"
                                            maxlength="50"
                                            :input_error="errors.block"
                                            v-model="dataLocation.block"
                                        />

                                        <inputForm
                                            id="floor"
                                            title="Số Tầng"
                                            type="text"
                                            :placeholder="placeholderText.floor"
                                            maxlength="10"
                                            :required="true"
                                            :input_error="errors.floor"
                                            v-model="dataLocation.floor"
                                        />
                                        <inputForm
                                            id="room"
                                            title="Số Phòng"
                                            type="text"
                                            :placeholder="placeholderText.room"
                                            maxlength="10"
                                            :required="true"
                                            :input_error="errors.room"
                                            v-model="dataLocation.room"
                                        />
                                    </template>

                                    <inputForm
                                        id="note"
                                        title="Ghi chú"
                                        type="text"
                                        :placeholder="
                                            dataLocation.locationtype == '1'
                                                ? placeholderText.noteHome
                                                : placeholderText.noteBuilding
                                        "
                                        maxlength="100"
                                        :input_error="errors.note"
                                        v-model="dataLocation.note"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Button -->
                <div class="container w-736 p-0 mt-4">
                    <div class="row">
                        <div class="col-12 d-flex flex-column">
                            <!--  -->
                            <button @click="checkForm" type="button" class="btn btn-custom orange">Tiếp tục</button>
                        </div>
                    </div>
                </div>
            </section>
            <!-- end./ STEP 1 -->
        </div>
        <!-- ./end MAIN CONTAINER -->
        <ConfirmModal
            ref="notification-modal"
            :title="notificationModalInfo.title"
            :iconId="notificationModalInfo.iconId"
            :message="notificationModalInfo.message"
            :okBtnText="notificationModalInfo.okBtnText"
            hideCancelBtn
            :checkBtn="isCheckBtn"
            @click-khtn="pushKHTN"
        />
        <ConfirmModal
            ref="error-modal"
            :title="errorModalInfo.title"
            :iconId="errorModalInfo.iconId"
            :message="errorModalInfo.message"
            :okBtnText="errorModalInfo.okBtnText"
            @click-cancel="backToHome"
            @click-ok="backToHome"
            hideCancelBtn
        />
    </LayoutPayment>
</template>

<script>
import moment from 'moment';
import Select2 from 'v-select2-component';

import * as api from '../module/api';
import * as api_sp from '../module/api-sp';
import { mixinRegister } from '../../../mycore/utils/mixin-register';
import { DATE_FORMAT } from '../../../configs/constants';
import { ROUTER_NAME } from '../module/routes';
import { DEFAULT_LOCATION } from '../../../configs/constants';
import { formatDate } from '@/mycore/module/utils';
import { mixins } from '../../mixin';


import LayoutPayment from '../../../layouts/LayoutPayment';
import BlockBack from '../component/blockBack.vue';
import ConfirmModal from '../component/confirmModal.vue';
import inputForm from '../component/inputForm.vue';
import UtmBannerRegister from '../../../mycore/components/UtmBannerRegister.vue';

const HOUSE_TYPE = '1';
const APARTMENT_TYPE = '2';
const MALE_GENDER = 'Nam';
const FEMALE_GENDER = 'Nữ';
const SEX_FIELD = 'sex';
const OTHER_PLACE = 'Nơi khác';
const MIN_AGE = 15;

export default {
    components: {
        Select2,
        BlockBack,
        ConfirmModal,
        LayoutPayment,
        inputForm,
        UtmBannerRegister,
    },
    data: function () {
        return {
            sectionTabsData: [],
            fields: {
                fullname: '',
                phonenumber: '',
                birthday: '',
                idNumber: '',
                sex: 1,
                email: '',
                latitude: '',
                longitude: '',
                note: '',
            },
            placeholderText: {
                room: 'Ví dụ: 1001',
                block: 'Ví dụ: Toà CT3B / Lô CT3B/ Block CT3B',
                floor: 'Ví dụ: 10',
                apartment: 'Nhập tên chung cư',
                noteBuilding: 'Ví dụ: qua cầu abc sẽ thấy chung cư',
                noteHome: 'Ví dụ: Gọi cho tôi trước 30 phút nhé!',
            },
            dataLocation: {
                locationid: '',
                locationname: '',
                districtid: '',
                districtname: '',
                wardid: '',
                wardname: '',
                streetid: '',
                streetname: '',
                street_user: '',
                is_street_user: 0,
                locationtype: HOUSE_TYPE,
                housenumber: '',
                buildingid: 0,
                buildingname: '',
                block: '',
                floor: '',
                room: '',
                note:''
            },
            isCheckBtn: false,
            listLocation: [],
            listDistrict: [],
            listWard: [],
            listStreet: [],
            listBuilding: [],
            orderId: '',
            listPackageInfo: [],
            listGender: [
                {
                    id: 1,
                    text: MALE_GENDER,
                },
                {
                    id: 2,
                    text: FEMALE_GENDER,
                },
            ],
            notificationModalInfo: {
                title: '',
                iconId: '',
                message: '',
                okBtnText: '',
            },
            errorModalInfo: {
                title: '',
                iconId: '',
                message: '',
                okBtnText: '',
            },
            errors: {},
            step: 1,
            isValidBirthday: false,
            checkPhone: 0,
            selectedService: {},
            nametitle: '',
            namebtn: '',
            defaultErrorMessage: 'Đã có lỗi xảy ra trong quá trình xử lý. Vui lòng thử lại',
            housenumberHint: 'Ví dụ: 16, Hẻm 32, Ngách 65, Ngõ 165',
            birthdayCalendarConfig: {
                max: moment().subtract(MIN_AGE, 'y').format(DATE_FORMAT.CALENDAR),
                placeholder: '01/01/1995',
                required: true,
                label: 'Ngày sinh',
                hideHeader: true,
            },
            validateMsg: {
                fullname: {
                    required: 'Vui lòng nhập họ và tên.',
                },
                phonenumber: {
                    required: 'Vui lòng nhập số điện thoại.',
                    format: 'Số điện thoại của bạn không đúng định dạng!',
                },
                sex: {
                    required: 'Vui lòng chọn giới tính.',
                },
                idNumber: {
                    required: 'Vui lòng nhập CMND/CCCD.',
                    format: 'CMND/CCCD phải từ 9 đến 12 chữ số.',
                },
                email: {
                    required: 'Vui lòng nhập email.',
                    format: 'Email không đúng định dạng.',
                },
                locationid: {
                    required: 'Vui lòng chọn tỉnh/thành phố.',
                },
                district: {
                    required: 'Vui lòng chọn quận/huyện.',
                },
                ward: {
                    required: 'Vui lòng chọn phường/xã.',
                },
                building: {
                    required: 'Vui lòng nhập tên chung cư.',
                },
                room: {
                    requiredInput: 'Vui lòng nhập số phòng.',
                },
                floor: {
                    requiredInput: 'Vui lòng nhập số tầng.',
                },
                street: {
                    required: 'Vui lòng chọn đường/phố.',
                    requiredInput: 'Vui lòng nhập tên đường/phố.',
                },
                housenumber: {
                    required: 'Vui lòng nhập địa chỉ/số nhà.',
                    max: 'Vui lòng nhập địa chỉ dưới 100 ký tự.',
                },
                birthday: {
                    required: 'Vui lòng nhập ngày sinh',
                    format: 'Ngày sinh không đúng định dạng',
                    max: 'Khách hàng phải lớn hơn 15 tuổi',
                    min: 'Năm sinh không hợp lệ',
                    valid: 'Ngày sinh không hợp lệ',
                },
                birthday: {
                    required: 'Vui lòng nhập ngày sinh',
                    format: 'Ngày sinh không đúng định dạng',
                    max: 'Khách hàng phải lớn hơn 15 tuổi',
                    min: 'Năm sinh không hợp lệ',
                },
            },
            serviceData: {},
            isFirstLoadBuilding: true,
            packagesErrorMessage:
                'Sản phẩm/Dịch vụ Quý khách vừa chọn hiện chưa mở bán. Xin quý khách vui lòng chọn lại sản phẩm/dịch vụ. Xin cảm ơn',
            initedDataLocation: false
        };
    },
    mixins: [mixinRegister, mixins],
    methods: {
        removeDataBuilding() {
            if (!this.isFirstLoadBuilding) {
                const clearData = ['buildingname', 'block', 'floor', 'room','note'];
                for (let e of clearData) {
                    this.dataLocation[e] = '';
                }
                this.dataLocation.buildingid = 0;
                this.listBuilding = [];
            }
        },
        changeApartment() {
            if (this.dataLocation.buildingid != 99999) {
                this.dataLocation.buildingname = this.listBuilding.filter(
                    (e) => parseInt(e.id) == this.dataLocation.buildingid
                )[0].text;
            } else {
                this.dataLocation.buildingname = '';
            }
            const clearData = ['block', 'floor', 'room'];
            for (let e of clearData) {
                this.dataLocation[e] = '';
            }
        },
        loadData() {
            if (sessionStorage.FptplaySelectedPackage) {
                this.selectedService = JSON.parse(sessionStorage.FptplaySelectedPackage);
            } else {
                this.getServiceFromUrl();
            }
            if (sessionStorage.dataRegister) {
                const dataRegister = JSON.parse(sessionStorage.dataRegister);
                for (const [key, value] of Object.entries(this.fields)) {
                    if (key === SEX_FIELD) {
                        this.fields[key] = dataRegister[key] || 1;
                        continue;
                    }
                    this.fields[key] = dataRegister[key] || '';
                }
            }

            if (sessionStorage.IsMap) {
                this.IsMap = sessionStorage.IsMap;
            }
        },
        callbackLocation(isSuccess, data, error) {
            if (isSuccess) {
                this.listLocation = data.data;
                return;
            }
            this.listLocation = [];
        },
        callbackDistrict(isSuccess, data, error) {
            if (isSuccess) {
                this.listDistrict = data.data;
                return;
            }
            this.listDistrict = [];
        },
        callbackWard(isSuccess, data, error) {
            if (isSuccess) {
                if (this.isFirstLoadBuilding) {
                    this.isFirstLoadBuilding = false;
                }
                this.listWard = data.data;
                return;
            }
            this.listWard = [];
        },
        callbackStreet(isSuccess, data, error) {
            if (!isSuccess) {
                this.listStreet = [];
                this.dataLocation.streetid = 0;
                this.dataLocation.streetname = '';
                this.dataLocation.housenumber = '';
            };
            if(data.error == 0){
                this.listStreet = data.data;
                if(this.listStreet.length > 0){
                    const result = this.listStreet.some(item => item.id == this.dataLocation.streetid);
                    if(result){
                        return;
                    };
                    this.dataLocation.streetid = 0;
                    this.dataLocation.streetname = '';
                    this.dataLocation.housenumber = '';
                }else{
                    this.dataLocation.streetid = 0;
                    this.dataLocation.streetname = '';
                    this.dataLocation.housenumber = '';
                };
            }else{
                this.listStreet = [];
                this.dataLocation.streetid = 0;
                this.dataLocation.streetname = '';
                this.dataLocation.housenumber = '';
            }
        },
        callbackBuilding(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    this.listBuilding = data.data;

                    if (!this.dataLocation.buildingid) {
                        this.dataLocation.buildingid = this.listBuilding[0].id;
                    }
                    if (this.dataLocation.buildingid != 99999) {
                        this.dataLocation.buildingname = this.listBuilding.filter(
                            (e) => parseInt(e.id) == this.dataLocation.buildingid
                        )[0].text;
                    }
                    return;
                }
                this.listBuilding = [];
            }
        },
        getDistrict(id) {
            this.dataLocation.locationname =
                this.listLocation.filter((e) => parseInt(e.id) == this.dataLocation.locationid)[0]?.text ?? '';
            this.listDistrict = [];
            this.listWard = [];
            this.listStreet = [];
            this.dataLocation.districtname = '';
            this.dataLocation.wardname = '';
            this.dataLocation.streetname = '';
            this.dataLocation.districtid = '';
            this.dataLocation.wardid = '';
            this.dataLocation.streetid = '';
            this.dataLocation.street_user = '';
            this.dataLocation.is_street_user = 0;
            api_sp.getDistrict(this.callbackDistrict, parseInt(id));
        },
        getWard() {
            this.listDistrict = JSON.parse(JSON.stringify(this.listDistrict));
            this.dataLocation.districtname =
                this.listDistrict.filter((e) => parseInt(e.id) == this.dataLocation.districtid)[0]?.text ?? '';

            this.listWard = [];
            this.listStreet = [];
            this.dataLocation.wardid = '';
            this.dataLocation.streetid = '';
            this.dataLocation.wardname = '';
            this.dataLocation.streetname = '';
            this.dataLocation.street_user = '';
            this.dataLocation.is_street_user = 0;
            api_sp.getWard(
                this.callbackWard,
                parseInt(this.dataLocation.locationid),
                parseInt(this.dataLocation.districtid)
            );
        },
        getStreet() {
            // this.listWard = JSON.parse(JSON.stringify(this.listWard));
            this.dataLocation.wardname =
                this.listWard.filter((e) => parseInt(e.id) == this.dataLocation.wardid)[0]?.text ?? '';
            this.listStreet = [];
            this.dataLocation.streetid = '';
            this.dataLocation.streetname = '';
            this.dataLocation.street_user = '';
            this.dataLocation.is_street_user = 0;
            api_sp.getStreet(
                this.callbackStreet,
                parseInt(this.dataLocation.locationid),
                parseInt(this.dataLocation.districtid),
                parseInt(this.dataLocation.wardid)
            );
        },
        checkStreet() {
            if (this.dataLocation.streetid === OTHER_PLACE) {
                this.dataLocation.is_street_user = 1;
            } else {
                // this.listStreet = JSON.parse(JSON.stringify(this.listStreet));
                this.dataLocation.streetname =
                    this.listStreet.filter((e) => parseInt(e.id) == this.dataLocation.streetid)[0]?.text ?? '';
            }
        },
        clearName() {
            this.fields.fullname = '';
        },
        validateName() {
            if (!this.fields.fullname) {
                this.errors.fullname = this.validateMsg.fullname.required;
            } else if (!this.fields.fullname.trim()) {
                this.errors.fullname = this.validateMsg.fullname.required;
            }
        },
        validatePhoneNumber() {
            if (this.fields.phonenumber === '') {
                this.checkPhone = 0;
                this.errors.phonenumber = this.validateMsg.phonenumber.required;
            } else {
                const vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
                const phone_regex = /(84[3|5|7|8|9])+([0-9]{8})\b/g;
                if (!vnf_regex.test(this.fields.phonenumber) && !this.fields.phonenumber.match(phone_regex)) {
                    this.checkPhone = 0;
                    this.errors.phonenumber = this.validateMsg.phonenumber.format;
                } else {
                    this.checkPhone = 1;
                }
            }
        },
        validateSex() {
            if (!this.fields.sex) {
                this.errors.sex = this.validateMsg.sex.required;
            }
        },
        validateBirthday() {
            if (!this.fields.birthday) {
                this.errors.birthday = this.validateMsg.birthday.required;
            } else {
                const birthdayRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
                if (!this.fields.birthday.match(birthdayRegex)) {
                    this.errors.birthday = this.validateMsg.birthday.format;
                } else {
                    let date = moment(this.fields.birthday, 'dd/mm/yyyy');
                    if (!date.isValid()) {
                        this.errors.birthday = this.validateMsg.birthday.format;
                    }
                    var years = moment().diff(moment(this.fields.birthday, 'DD-MM-YYYY'), 'years');
                    if (years < 15) {
                        this.errors.birthday = this.validateMsg.birthday.max;
                    }
                    if (years > 100) {
                        this.errors.birthday = this.validateMsg.birthday.min;
                    }
                }
            }
            this.isValidBirthday = true;
        },
        validateIdNumber() {
            if (!this.fields.idNumber) {
                this.errors.idNumber = this.validateMsg.idNumber.required;
                return;
            }
            const trimId = this.fields.idNumber.trim();
            const idNumberRegex = /^[0-9]{9,12}$/;
            if (!idNumberRegex.test(trimId)) {
                this.errors.idNumber = this.validateMsg.idNumber.format;
            }
        },
        validateEmail() {
            if (!this.fields.email) {
                return;
            }
            const emailRegex =
                /^([a-zA-Z0-9]{2,}|[a-zA-Z0-9]+([\.\-\_][a-zA-Z0-9]+))([\.\-\_][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\-[a-zA-Z0-9]+)*(\.([a-zA-Z0-9]{2,}|[a-zA-Z0-9]+([\-][a-zA-Z0-9]+)+))+$/;
            if (!emailRegex.test(this.fields.email)) {
                this.errors.email = this.validateMsg.email.format;
            }
        },
        validateLocation() {
            if (!this.dataLocation.locationid) {
                this.errors.locationid = this.validateMsg.locationid.required;
            }
        },
        validateDistrict() {
            if (!this.dataLocation.districtid) {
                this.errors.district = this.validateMsg.district.required;
            }
        },
        validateWard() {
            if (!this.dataLocation.wardid) {
                this.errors.ward = this.validateMsg.ward.required;
            }
        },
        validateStreet() {
            if (!this.dataLocation.streetid) {
                this.errors.street = this.validateMsg.street.required;
            }
        },
        validateStreetUser() {
            if (this.dataLocation.is_street_user === 1 && this.dataLocation.street_user === '') {
                this.errors.street_user = this.validateMsg.street.requiredInput;
            }
        },
        validateHousenumber() {
            this.dataLocation.housenumber = this.dataLocation.housenumber.trim();
            if (!this.dataLocation.housenumber) {
                this.errors.housenumber = this.validateMsg.housenumber.required;
            }
        },
        validateBuilding() {
            this.dataLocation.buildingname = this.dataLocation.buildingname.trim();
            if (!this.dataLocation.buildingname) {
                this.errors.building = this.validateMsg.building.required;
            }
        },
        validateRoom() {
            this.dataLocation.room = this.dataLocation.room.trim();
            if (!this.dataLocation.room) {
                this.errors.room = this.validateMsg.room.requiredInput;
            }
        },
        validateFloor() {
            this.dataLocation.floor = this.dataLocation.floor.trim();
            if (!this.dataLocation.floor) {
                this.errors.floor = this.validateMsg.floor.requiredInput;
            }
        },
        disabledDate(date) {
            const today = new Date();
            const vali = today.setDate(today.getDate() - 5480);
            return date > vali;
        },
        isValidAll() {
            this.errors = {};
            this.validateName();
            this.validatePhoneNumber();
            this.validateBirthday();
            this.validateIdNumber();
            this.validateSex();
            this.validateEmail();
            this.validateLocation();
            this.validateDistrict();
            this.validateWard();
            this.validateStreet();
            this.validateStreetUser();
            if (this.dataLocation.locationtype == HOUSE_TYPE) {
                this.validateHousenumber();
            } else {
                this.dataLocation.block = this.dataLocation.block.trim()
                this.validateBuilding();
                this.validateRoom();
                this.validateFloor();
            }

            if (Object.keys(this.errors).length === 0 && this.isValidBirthday) {
                return true;
            }
            return false;
        },
        trimFieldsInObj(obj) {
            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                if (typeof value === 'string' || value instanceof String) {
                    result[key] = value.trim();
                    continue;
                }
                result[key] = value;
            }
            return result;
        },
        saveInfoToSession() {
            sessionStorage.dataRegister = JSON.stringify(this.trimFieldsInObj(this.fields));
            this.saveLocationData();
            sessionStorage.listLocation = JSON.stringify(this.listLocation);
            sessionStorage.listDistrict = JSON.stringify(this.listDistrict);
            sessionStorage.listWard = JSON.stringify(this.listWadataLocationrd);
            sessionStorage.listStreet = JSON.stringify(this.listStreet);
            sessionStorage.step = 2;
        },
        saveLocationData() {
            const locationname =
                this.listLocation.filter((item) => '' + item.id === '' + this.dataLocation.locationid)[0]?.text ?? '';

            const districtname =
                this.listDistrict.filter((item) => '' + item.id === '' + this.dataLocation.districtid)[0]?.text ?? '';
            const wardname =
                this.listWard.filter((item) => '' + item.id === '' + this.dataLocation.wardid)[0]?.text ?? '';
            const streetname =
                this.listStreet.filter((item) => '' + item.id === '' + this.dataLocation.streetid)[0]?.text ?? '';

            const locationInfo = {
                ...this.dataLocation,
                locationname,
                districtname,
                wardname,
                streetname,
            };
            localStorage.dataLocation = JSON.stringify(locationInfo);
        },
        showNotificationModal(
            message,
            title = this.nametitle ? this.nametitle : 'Thông báo',
            iconId = '#icon-voucher',
            okBtnText = this.namebtn ? this.namebtn : 'Đồng ý'
        ) {
            this.notificationModalInfo = {
                title,
                iconId,
                message,
                okBtnText,
            };
            this.$refs['notification-modal'].showModal();
        },
        createInternetOrder() {
            // lấy tên thành phố
            this.listLocation = JSON.parse(JSON.stringify(this.listLocation));
            const locationname =
                this.listLocation.filter((item) => '' + item.id === '' + this.dataLocation.locationid)[0]?.text ?? '';

            // lấy tên tỉnh
            this.listDistrict = JSON.parse(JSON.stringify(this.listDistrict));
            const districtname =
                this.listDistrict.filter((item) => '' + item.id === '' + this.dataLocation.districtid)[0]?.text ?? '';

            // lấy tên quận huyện
            this.listWard = JSON.parse(JSON.stringify(this.listWard));
            const wardname =
                this.listWard.filter((item) => '' + item.id === '' + this.dataLocation.wardid)[0]?.text ?? '';

            // lấy tên đường
            this.listStreet = JSON.parse(JSON.stringify(this.listStreet));
            const streetname =
                this.listStreet.filter((item) => '' + item.id === '' + this.dataLocation.streetid)[0]?.text ?? '';

            const orderInfo = {
                OrderCode: sessionStorage.getItem('ordercode'),
                Id: parseInt(this.getFromSessions('orderid') || 0),
                OrderType: 1,
                Position: this.fields.latitude + ';' + this.fields.longitude,
                TrackingID: this.getTrackingID() || '',
                BillType: 5,
                SaleTeamId:this.getSaleTeamId(),
                PublicToken: this.getCookie('PublicToken') || '',
                CampInfo: {
                    CampSource: sessionStorage.utm_source || '',
                    CampMedium: sessionStorage.utm_medium || '',
                    CampName: sessionStorage.utm_campaign || '',
                    CampTerm: sessionStorage.utm_term || '',
                    CampContent: sessionStorage.utm_content || '',
                    CampExtra: sessionStorage.extra_tracking ? sessionStorage.extra_tracking : ''
                },
                ReCare: '',
                ReferralCode: '',
            };

            if (Object.keys(this.selectedService).length > 0 && this.selectedService.hasOwnProperty('id')) {
                orderInfo.OrderCode = this.selectedService.id;
            }

            if (sessionStorage.utm_source) {
                orderInfo.OrderCode = sessionStorage.ordercode || '';
                orderInfo.CampInfo = {
                    CampSource: sessionStorage.utm_source || '',
                    CampMedium: sessionStorage.utm_medium || '',
                    CampName: sessionStorage.utm_campaign || '',
                    CampTerm: sessionStorage.utm_term || '',
                    CampContent: sessionStorage.utm_content || '',
                    CampExtra: sessionStorage.extra_tracking ? sessionStorage.extra_tracking : ''
                };
            }
            if (sessionStorage.latitude) {
                orderInfo.Position = sessionStorage.latitude + ';' + sessionStorage.longitude;
                this.fields.latitude = sessionStorage.latitude;
                this.fields.longitude = sessionStorage.longitude;
            }
            const customerInfo = {
                FullName: this.fields.fullname,
                IDCardType: 1,
                IDCard: this.fields.idNumber,
                DOB: this.fields.birthday,
                Email: this.fields.email,
                Gender: parseInt(this.fields.sex),
                PhoneSMS: this.fields.phonenumber.trim(),
                LocationId: parseInt(this.dataLocation.locationid),
                LocaltionName: locationname,
                DistrictId: parseInt(this.dataLocation.districtid),
                DistrictName: districtname,
                WardId: parseInt(this.dataLocation.wardid),
                WardName: wardname,
                StreetId: parseInt(this.dataLocation.streetid),
                StreetName: streetname,
                TypeHouse: parseInt(this.dataLocation.locationtype),
                BuildingIdMain: parseInt(this.dataLocation.buildingid) || 0,
                BuildingNameMain: this.dataLocation.buildingname,
                BlockMain: this.dataLocation.block,
                FloorMain: this.dataLocation.floor,
                RoomMain: this.dataLocation.room,
                AddressNo: this.dataLocation.housenumber,
                BillingAddress: this.getBillingAddress(this.dataLocation),
                NoteAddress: this.dataLocation.note,
            };
            sessionStorage.locationid = parseInt(this.dataLocation.locationid);
            sessionStorage.districtid = parseInt(this.dataLocation.districtid);
            sessionStorage.wardid = parseInt(this.dataLocation.wardid);
            const orderData = {
                OrderInfo: orderInfo,
                CustomerInfo: customerInfo,
            };
            api_sp.createFptPlayOrder(this.callbackCreateFptPlayOrder, orderData);
        },
        getBillingAddress(data) {
            let result = '';
            if (this.dataLocation.locationtype == APARTMENT_TYPE) {
                if (data.block) {
                    result += data.block + ', ';
                }
                result +=
                    'Tầng ' +
                    data.floor +
                    ', ' +
                    'Phòng ' +
                    data.room +
                    ', ' +
                    data.buildingname +
                    ', ' +
                    data.streetname +
                    ', ' +
                    data.wardname +
                    ', ' +
                    data.districtname +
                    ', ' +
                    data.locationname;
            } else {
                result +=
                    data.housenumber +
                    data.street_user +
                    ' ' +
                    data.streetname +
                    ', ' +
                    data.wardname +
                    ', ' +
                    data.districtname +
                    ', ' +
                    data.locationname;
            }
            return result;
        },
        callbackCreateFptPlayOrder(isSuccess, data, error) {
            if (isSuccess) {
                if (data.error == 0) {
                    if (data.data.Code != 1) {
                        this.$store.dispatch('system/updateLoading', false);
                        this.showErrorForUpdateSurvey(data.data.Desc);
                        return;
                    } else {
                        const dataSurvey = data.data;
                        if (dataSurvey.Address !== '') {
                            sessionStorage.address = dataSurvey.Address;
                        }
                        if (dataSurvey.OrderCode !== '') {
                            this.sessionSet('ordercode20', dataSurvey.OrderCode, 20);

                            sessionStorage.ordercode = dataSurvey.OrderCode;
                            sessionStorage.orderid = JSON.stringify(dataSurvey.OrderId);
                            window.scrollTo(0, 0);
                            this.$router
                                .push({
                                    name: ROUTER_NAME.service,
                                })
                                .catch(() => {});
                        }
                        return;
                    }
                } else {
                    if (data.error == 1) {
                        this.$store.dispatch('system/updateLoading', false);
                        this.showErrorForUpdateSurvey(data.message);
                    }
                    if (data.data.data_error) {
                        if (data.data.data_error.Code == -2) {
                            this.isCheckBtn = true;
                            this.nametitle = 'Số điện thoại đã được sử dụng';
                            this.namebtn = 'Thay đổi số điện thoại khác';
                            this.orderId = data.data.data_error.OrderId || '';
                            sessionStorage.setItem('order_id_customer', this.orderId);
                        } else {
                            this.isCheckBtn = false;
                            this.namebtn = 'Đồng ý';
                            this.nametitle = 'Thông báo';
                        }
                    } else {
                        this.$store.dispatch('system/updateLoading', false);
                        this.showErrorForUpdateSurvey(data.message);
                        return;
                    }
                    this.$store.dispatch('system/updateLoading', false);
                    this.showErrorForUpdateSurvey(data.message);
                    return;
                }
            }
        },
        showErrorForUpdateSurvey(msg) {
            const errMsg = msg ? msg : this.defaultErrorMessage;
            this.showNotificationModal(errMsg);
        },
        checkForm(e) {
            e.preventDefault();
            const listSessionName = ['keyProduct', 'countSub'];
            for (let i = 0; i < listSessionName.length; i++) {
                if (sessionStorage[listSessionName[i]]) {
                    sessionStorage.removeItem(listSessionName[i]);
                }
            }
            if (this.isValidAll()) {
                this.$store.dispatch('system/updateLoading', true);
                this.saveInfoToSession();
                this.createInternetOrder();
            } else {
                this.scrollToError();
            }
        },
        backToHome() {
            window.scrollTo(0, 0);
            this.$router
                .push({
                    name: ROUTER_NAME.home,
                })
                .catch(() => {});
        },
        loadLocationData() {
            if (localStorage.dataLocation) {
                this.loadDataLocationSession();
            } else {
                this.loadDefaultDataLocation();
            }
        },
        loadDataLocationSession() {
            if (localStorage.dataLocation) {
                const temp = JSON.parse(localStorage.dataLocation);
                if (temp.locationid) {
                    this.dataLocation.locationid = temp.locationid;
                    this.dataLocation.locationname = temp.locationname;
                    api_sp.getLocation(this.callbackLocation);
                    api_sp.getDistrict(this.callbackDistrict, parseInt(this.dataLocation.locationid));
                }
                if (temp.districtid) {
                    this.dataLocation.districtid = temp.districtid;
                    this.dataLocation.districtname = temp.districtname;
                    api_sp.getWard(
                        this.callbackWard,
                        parseInt(this.dataLocation.locationid),
                        parseInt(this.dataLocation.districtid)
                    );
                }
                if (temp.wardid) {
                    this.dataLocation.wardid = temp.wardid;
                    this.dataLocation.wardname = temp.wardname;
                    api_sp.getStreet(
                        this.callbackStreet,
                        parseInt(this.dataLocation.locationid),
                        parseInt(this.dataLocation.districtid),
                        parseInt(this.dataLocation.wardid)
                    );
                    if (temp.housenumber) {
                        this.dataLocation.housenumber = temp.housenumber;
                    }
                }

                if (!temp.locationtype || temp.locationtype === undefined) {
                    this.dataLocation.locationtype = HOUSE_TYPE;
                    const list = ['buildingname', 'buildingid', 'block', 'floor', 'room','note'];
                    for (let e of list) {
                        this.dataLocation[e] = '';
                    }
                } else {
                    const list = [
                        'locationtype',
                        'buildingid',
                        'buildingname',
                        'block',
                        'floor',
                        'room',
                        'streetid',
                        'streetname',
                        'note'
                    ];
                    for (let e of list) {
                        this.dataLocation[e] = temp[e];
                    }
                }
            }
            setTimeout(() => {
                this.initedDataLocation = true
            },500)
        },
        loadDefaultDataLocation() {
            this.dataLocation.locationid = DEFAULT_LOCATION.locationid;
            this.dataLocation.districtid = DEFAULT_LOCATION.districtid;
            this.dataLocation.wardid = DEFAULT_LOCATION.wardid;
            this.dataLocation.locationname = DEFAULT_LOCATION.locationname;
            this.dataLocation.districtname = DEFAULT_LOCATION.districtname;
            this.dataLocation.wardname = DEFAULT_LOCATION.wardname;
            api_sp.getLocation(this.callbackLocation);
            api_sp.getDistrict(this.callbackDistrict, parseInt(this.dataLocation.locationid));
            api_sp.getWard(
                this.callbackWard,
                parseInt(this.dataLocation.locationid),
                parseInt(this.dataLocation.districtid)
            );
            api_sp.getStreet(
                this.callbackStreet,
                parseInt(this.dataLocation.locationid),
                parseInt(this.dataLocation.districtid),
                parseInt(this.dataLocation.wardid)
            );
            setTimeout(() => {
                this.initedDataLocation = true
            },500)
        },
        pushKHTN() {
            api.getPotentialCustomer(this.callbackPotentialCustomer, parseInt(this.orderId));
        },
        callbackPotentialCustomer(isSuccess, data, error) {
            if (isSuccess) {
                this.$router
                    .push({
                        name: ROUTER_NAME.finishPotentialCustomers,
                    })
                    .catch(() => {});
            }
        },
        scrollToError() {
            setTimeout(() => {
                const errorElement = document.getElementsByClassName('form-text text-12 clo-red');
                if (errorElement) {
                    const top = errorElement[0].parentNode.offsetTop;
                    window.scrollTo({
                        top: top,
                        behavior: 'smooth',
                    });
                }
            }, 500);
        },
        getServiceFromUrl() {
            const serviceCode = this.$route.params.servicecode;
            if (serviceCode && sessionStorage.updateservice === undefined) {
                if (serviceCode) {
                    this.$store.dispatch('system/updateLoading', true);
                    api_sp.getServiceFromName(this.callbackGetServiceFromName, serviceCode);
                } else {
                    this.showErrorModal(this.packagesErrorMessage);
                }
            } else {
                if (sessionStorage.FptplaySelectedPackage) {
                    this.selectedService = JSON.parse(sessionStorage.FptplaySelectedPackage);
                } else {
                    this.showErrorModal(
                        'Quý khách vui lòng chọn gói sản phẩm trước khi đăng ký mua hàng. Xin trân trọng cảm ơn quý khách.'
                    );
                }
            }
        },
        callbackGetServiceFromName(isSuccess, data, error) {
            if (isSuccess) {
                this.$store.dispatch('system/updateLoading', false);
                if (data.error == 0) {
                    this.serviceData = data.data;
                    this.$store.dispatch('fptplay/updateSelectedPackage', this.serviceData);
                } else {
                    this.$store.dispatch('system/showDialog', {
                        description: data.message,
                    });
                }
            }
        },
        showErrorModal(message, title = 'Thông báo', iconId = '#icon-voucher', okBtnText = 'Đồng ý') {
            this.errorModalInfo = {
                title,
                iconId,
                message,
                okBtnText,
            };
            this.$refs['error-modal'].showModal();
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                if (modalId === '__BVID__28') {
                    this.backToHome();
                }
            });
        },
        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    },
    watch: {
        'fields.birthday': function (val) {
            this.fields.birthday = formatDate(val);
        },
        updateDataBuilding(val, oldVal) {
            this.removeDataBuilding();
            if (val) {
                api_sp.getBuilding(
                    this.callbackBuilding,
                    this.getSaleTeamId(),
                    parseInt(this.dataLocation.locationid),
                    parseInt(this.dataLocation.districtid),
                    parseInt(this.dataLocation.wardid)
                );
            }
        },
        'dataLocation.locationtype'(val, oldVal) {
            if (val == HOUSE_TYPE) {
                this.removeDataBuilding();
            } else {
                if (this.initedDataLocation){
                    this.dataLocation.note = '';
                }
                this.dataLocation.housenumber = '';
                this.placeholderNoteInput = this.placeholderText.noteBuilding;
            }
        },
    },
    mounted() {
        this.loadLocationData();
        this.loadData();
    },
    created() {
        sessionStorage.step = 1;
        this.$store.dispatch('fptplay/updateStep', 1);
    },
    computed: {
        updateDataBuilding() {
            if (this.dataLocation.locationtype == APARTMENT_TYPE) {
                return this.dataLocation.wardid;
            }
            return '';
        },
    },
};
</script>

<style>
.mx-datepicker {
    position: static;
    width: 100%;
}

@media only screen and (max-width: 600px) {
    .form-infomation .form-calendar .b-calendar {
        right: 0px;
        min-width: 248px;
    }
}
</style>
